import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { useTranslation } from '../../hooks/useTranslation';

const FAQSection = () => {
  const { t } = useTranslation();
  const faq = t('faq.faqs');

  return (
    <section className="py-24" style={{background: '#121211'}}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" style={{color: '#fff'}}>
            {t('faq.title')}
          </h2>
          <p className="text-xl text-slate-400" style={{color: '#fff'}}>
            {t('faq.subtitle')}
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faq.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="backdrop-blur-sm border border-slate-800 rounded-2xl px-6 hover:border-slate-700 transition-colors duration-300" style={{background: '#171715'}}
            >
              <AccordionTrigger className="text-left text-white  py-6" style={{fontSize: 16}}>
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 pb-6 leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact CTA */}
        <div className="text-center mt-12">
          <p className="mb-4" style={{color: '#fff'}}>
            {t('faq.stillHaveQuestions')}
          </p>
          <div className="space-x-4">
            <a
              href="mailto:support@ip9.io"
              className="text-cyan-400 hover:text-cyan-300 font-medium transition-colors duration-200"
            >
              {t('faq.contactSupport')}
            </a>
            <span className="text-slate-600">•</span>
            <a
              href="/contact"
              className="text-cyan-400 hover:text-cyan-300 font-medium transition-colors duration-200"
            >
              {t('faq.scheduleCall')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;